import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { catchError, throwError } from 'rxjs';
import { SKIP_AUTH_INTERCEPTOR } from './http-context.tokens';

function redirectFromProtectedRoutes(router: Router): void {
  const path = (router.url.split('?')[0] || '').toLowerCase();
  const protectedRoots = ['/profile', '/orders', '/checkout', '/success'];
  if (protectedRoots.some((p) => path === p || path.startsWith(p + '/'))) {
    void router.navigateByUrl('/');
  }
}

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (req.context.get(SKIP_AUTH_INTERCEPTOR)) {
    return next(req).pipe(
      catchError((err: HttpErrorResponse) => {
        if (err.status === 401) {
          authService.clearAuth();
          redirectFromProtectedRoutes(router);
        }
        return throwError(() => err);
      })
    );
  }

  let token = authService.getToken();

  if (token && authService.isAccessTokenExpired()) {
    authService.clearAuth();
    redirectFromProtectedRoutes(router);
    token = null;
  }

  const outgoing = token
    ? req.clone({
        setHeaders: { Authorization: `Bearer ${token}` }
      })
    : req;

  const hadBearer = !!token;

  return next(outgoing).pipe(
    catchError((err: HttpErrorResponse) => {
      if (err.status === 401 && hadBearer) {
        authService.clearAuth();
        redirectFromProtectedRoutes(router);
      }
      return throwError(() => err);
    })
  );
};
